import React, {useState} from "react";
import {  Statistic, Card, Row, Col } from 'antd'
import { 
  SubscriptionIcon, 
  TipsIcon, 
  TrafficIcon,
  RefferalIcon,
  OrganicIcon, 
  FreeSubscriptionIcon,
  PostsIcon,
  LikesIcon,
  SharesIcon,
  ClicksIcon,
  OptionIcon,
  ActivityIcon,
  PassiveIcon
  } from "../Icon";
import { Typography, Button, List, PageHeader } from 'antd';
const { Text, Paragraph } = Typography;


const Activity = () => {

    const activityArr = [
      {
        name: "Traffic",
        someAmount: '4 384',
        status: true
      },
      {
        name: "Refferal",
        someAmount: '4 384',
        status: false
      },
      {
        name: "Organic",
        someAmount: '4 384',
        status: false
      },
      {
        name: "Free subscription",
        someAmount: '4 384',
        status: false
      },
      {
        name: "Paid subscription",
        someAmount: '4 384',
        status: false
      },
      {
        name: "Posts",
        someAmount: '4 384',
        status: true
      },
      {
        name: "Likes",
        someAmount: '4 384',
        status: false
      },
      {
        name: "Number of tips",
        someAmount: '4 384',
        status: false
      },
      {
        name: "Shares",
        someAmount: '4 384',
        status: true
      },
      {
        name: "Clicks",
        someAmount: '4 384',
        status: false
      }
    ]
    return(
      <div className="dashboard-activity">
        <Card className="activity-content">
          <PageHeader
          title="Activity"
          className="activity-header"
          />
         {activityArr.map(element => (
           <div>
             <div className={element.status ? 'activity-total' : 'activitye-top-rows'}>
               <div className="activity-columns">
                 {
                 element.name === 'Traffic' ? <TrafficIcon /> 
                 : element.name === 'Refferal' ? <RefferalIcon />
                 : element.name === 'Organic' ? <OrganicIcon/>
                 : element.name === 'Refferal' ? <  RefferalIcon/>
                 : element.name === 'Free subscription' ? <FreeSubscriptionIcon/>
                 : element.name === 'Paid subscription' ? <SubscriptionIcon/>
                 : element.name === 'Posts' ? <PostsIcon/>
                 : element.name === 'Likes' ? <LikesIcon/>
                 : element.name === 'Number of tips' ? <TipsIcon/>
                 : element.name === 'Shares' ? <SharesIcon/>
                 : <ClicksIcon />
                 }
                 
                 <Text className="activity-sub-titles">{element.name}</Text>
              </div>
              <div className="activity-columns">
                <Text className="activity-amount">{element.someAmount}</Text>
                {element.status ? <  ActivityIcon /> : <PassiveIcon />}
                
              </div>
            </div>
          </div>
         ))}
        </Card>
      </div>
    )
}

export default Activity;